export default "__VITE_ASSET__jbw$feoe__"